import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button } from "react-bootstrap"
import "../../css/BobbingIcon.css"
import { ReactComponent as ClosedSign } from "../../icon/closed-sign.svg"
import "../../css/SMPLButton.css"
import ClosedGraphic from '../common/ClosedGraphic'
import { Gallery } from '../../library/Gallery'

interface ClosedModalProps {
  show: boolean
  gallery: Gallery
}

export default function ClosedModal({ show, gallery }: ClosedModalProps) {
  const { t } = useTranslation()

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Body className="p-4">
        <ClosedGraphic horizontalOffset="-85px" verticalOffset="-70px">
          <ClosedSign />
        </ClosedGraphic>
        <h1>{t("closed.heading")}</h1>
        <p>{t("closed.text")}</p>
        {gallery && gallery.totalUploads > 0 && gallery.privacy === "public" &&
          <Button variant="smpl" href={gallery.url}>{t("closed.viewGallery")}</Button>
        }
      </Modal.Body>
    </Modal>
  )
}
